import { useEffect } from "react";
import { riskAreaAndComplianceAreaKeyStorageKey } from "../riskAssessment/riskAssessments/RIskAssessments.hooks";
import { getTabCustomerId } from "@common/api/apiShared";

export function switchCustomerInStorage(customerId: string): void {
    localStorage.removeItem(riskAreaAndComplianceAreaKeyStorageKey);
    localStorage.setItem("customerId", customerId);
}

// A reload, a middle-clicked link or a new tab starts from localStorage, so the tab being worked in must own it
export function useClaimStoredCustomerOnFocus() {
    useEffect(() => {
        window.addEventListener("focus", claimStoredCustomer);
        return () => window.removeEventListener("focus", claimStoredCustomer);
    }, []);
}

function claimStoredCustomer() {
    const storedCustomerId = localStorage.getItem("customerId");
    const tabCustomerId = getTabCustomerId();

    // Single-customer users never store a customer, and the top bar only offers "change organization" once one is stored
    if (storedCustomerId !== null && tabCustomerId !== null && storedCustomerId !== tabCustomerId) {
        switchCustomerInStorage(tabCustomerId);
    }
}
